import { NgModule } from '@angular/core';
import { SharedModule } from '../shared.module';
import { AclDirective } from './acl.directive';
const COMPONENTS = [
  AclDirective,
];

@NgModule({
  declarations: [
    ...COMPONENTS,
  ],
  imports: [
    SharedModule
  ],
  exports: [
    ...COMPONENTS
  ]
})
export class AclModule { }
